import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { readClients } from '@/store/clients'
import { applyHighContrastDocumentFlag, readHighContrastPreference } from '@/utils/highContrastPalette'
import App from './App'
import './registerPwa'
import './styles/global.css'

applyHighContrastDocumentFlag(readHighContrastPreference())

// Seed persistent demo clients into localStorage on every app load
readClients()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
